import { render, staticRenderFns } from "./LayananPemeliharaanPage.vue?vue&type=template&id=84c5fa0a"
import script from "./LayananPemeliharaanPage.vue?vue&type=script&lang=js"
export * from "./LayananPemeliharaanPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports